// @generated by protoc-gen-es v1.10.0
// @generated from file penumbra/core/component/fee/v1/fee.proto (package penumbra.core.component.fee.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Amount } from "../../../num/v1/num_pb.js";
import { AssetId } from "../../../asset/v1/asset_pb.js";

/**
 * Specifies fees paid by a transaction.
 *
 * @generated from message penumbra.core.component.fee.v1.Fee
 */
export const Fee = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.fee.v1.Fee",
  () => [
    { no: 1, name: "amount", kind: "message", T: Amount },
    { no: 2, name: "asset_id", kind: "message", T: AssetId },
  ],
);

/**
 * Gas usage for a transaction.
 *
 * Gas used is multiplied by `GasPrices` to determine a `Fee`.
 *
 * @generated from message penumbra.core.component.fee.v1.Gas
 */
export const Gas = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.fee.v1.Gas",
  () => [
    { no: 1, name: "block_space", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "compact_block_space", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "verification", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: "execution", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * @generated from message penumbra.core.component.fee.v1.GasPrices
 */
export const GasPrices = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.fee.v1.GasPrices",
  () => [
    { no: 15, name: "asset_id", kind: "message", T: AssetId },
    { no: 1, name: "block_space_price", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "compact_block_space_price", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "verification_price", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: "execution_price", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * @generated from message penumbra.core.component.fee.v1.FeeTier
 */
export const FeeTier = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.fee.v1.FeeTier",
  () => [
    { no: 1, name: "fee_tier", kind: "enum", T: proto3.getEnumType(FeeTier_Tier) },
  ],
);

/**
 * The tier for the fee.
 *
 * @generated from enum penumbra.core.component.fee.v1.FeeTier.Tier
 */
export const FeeTier_Tier = /*@__PURE__*/ proto3.makeEnum(
  "penumbra.core.component.fee.v1.FeeTier.Tier",
  [
    {no: 0, name: "TIER_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TIER_LOW", localName: "LOW"},
    {no: 2, name: "TIER_MEDIUM", localName: "MEDIUM"},
    {no: 3, name: "TIER_HIGH", localName: "HIGH"},
  ],
);

/**
 * Fee component configuration data.
 *
 * @generated from message penumbra.core.component.fee.v1.FeeParameters
 */
export const FeeParameters = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.fee.v1.FeeParameters",
  () => [
    { no: 1, name: "fixed_gas_prices", kind: "message", T: GasPrices },
    { no: 2, name: "fixed_alt_gas_prices", kind: "message", T: GasPrices, repeated: true },
  ],
);

/**
 * Fee-specific genesis content.
 *
 * @generated from message penumbra.core.component.fee.v1.GenesisContent
 */
export const GenesisContent = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.fee.v1.GenesisContent",
  () => [
    { no: 1, name: "fee_params", kind: "message", T: FeeParameters },
  ],
);

/**
 * @generated from message penumbra.core.component.fee.v1.CurrentGasPricesRequest
 */
export const CurrentGasPricesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.fee.v1.CurrentGasPricesRequest",
  [],
);

/**
 * @generated from message penumbra.core.component.fee.v1.CurrentGasPricesResponse
 */
export const CurrentGasPricesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.fee.v1.CurrentGasPricesResponse",
  () => [
    { no: 1, name: "gas_prices", kind: "message", T: GasPrices },
    { no: 2, name: "alt_gas_prices", kind: "message", T: GasPrices, repeated: true },
  ],
);

/**
 * Emitted during fee payment.
 *
 * @generated from message penumbra.core.component.fee.v1.EventPaidFee
 */
export const EventPaidFee = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.fee.v1.EventPaidFee",
  () => [
    { no: 1, name: "fee", kind: "message", T: Fee },
    { no: 2, name: "base_fee", kind: "message", T: Fee },
    { no: 3, name: "tip", kind: "message", T: Fee },
    { no: 4, name: "gas_used", kind: "message", T: Gas },
  ],
);

/**
 * Emitted as a summary of fees in the block.
 *
 * @generated from message penumbra.core.component.fee.v1.EventBlockFees
 */
export const EventBlockFees = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.fee.v1.EventBlockFees",
  () => [
    { no: 1, name: "swapped_fee_total", kind: "message", T: Fee },
    { no: 2, name: "swapped_base_fee_total", kind: "message", T: Fee },
    { no: 3, name: "swapped_tip_total", kind: "message", T: Fee },
  ],
);

